<template>
  <ActicsLandingPageLayout>
    <ActicsMenuBoxes class="grow-1 px-3 mt-5" />
  </ActicsLandingPageLayout>
</template>
<script>
import ActicsMenuBoxes from '../../components/actics/landingPage/ActicsMenuBoxes.vue';
import ActicsLandingPageLayout from '../../components/actics/landingPage/ActicsLandingPageLayout.vue';
export default {
  title: 'Actics Landing Page',
  components: { ActicsMenuBoxes, ActicsLandingPageLayout },
  methods: {
    createMenuItems() {
      // var invisionNowDescription = 'Drive incremental value and actions throughout your product lifecycle with ACTICS flagship end-to-end patient solutions analytics.';
      var scipherDescription = 'Advanced AI and machine learning for precision patient and provider finding.';
      var medInsightsDescription = 'Dynamic metrics, analytics, and customer insights to understand medical information contact center interactions including adverse event and product complaint reporting.';
      // var marketAccessDescription = 'Accurate and timely market share, coverage, payer, and pull-through insights to inform optimal price and contract strategy.';
      // var spCoreDescription = 'Aggregate, unify, and analyze your brand\'s specialty pharmacy data for optimal patient-centric commercial strategy.';
      // var sagerXDescription = 'Leading integrated software and strategy solution to help achieve top-in-class influencer engagement directly linked to organizational goals.';
      var enterpriseMetricsDescription = 'Enterprise and Service Line Commercial, Operational, and Productivity metrics.';
      var itOperationsDescription = 'IT Operations, Security and Phone Metrics.';

      var user = this.$store.state.user;

      this.$store.state.actics.menuItems = [
        {
          title: ['SCIPHER'],
          titleShort: ['S'],
          description: scipherDescription,
          link: this.getFlag('use-only-actics-layout') ? { name: 'cohorts' } : '/Analytics/Cohort/Manage',
          buttonText: 'LAUNCH',
          hide: !(user.isMainAdmin || user.isAnalyst),
        },
        // {
        //   title: ['SCIPHER'],
        //   titleShort: ['S'],
        //   description: scipherDescription,
        //   link: { name: 'scipherRequestDemo' },
        //   buttonText: 'LEARN MORE',
        //   hide: user.isMainAdmin || user.isAnalyst,
        // },
        // {
        //   title: ['SP', 'CORE'],
        //   titleShort: ['S', 'P'],
        //   description: spCoreDescription,
        //   link: { name: 'spcoreRequestDemo' },
        //   buttonText: 'LEARN MORE',
        //   hide: user.isMainAdmin || user.isAnalyst,
        // },
        {
          title: ['MED', 'INSIGHTS'],
          titleShort: ['M', 'I'],
          description: medInsightsDescription,
          link: { name: 'medInsights' },
          buttonText: 'LAUNCH',
          hide: !this.getFlag('DAS-701'),
        },
        {
          title: ['ENTERPRISE', 'METRICS'],
          titleShort: ['E', 'M'],
          description: enterpriseMetricsDescription,
          link: { name: 'enterpriseMetrics' },
          buttonText: 'LAUNCH',
          hide: !this.getFlag('DAS-826'),
        },
        {
          title: ['IT', 'OPERATIONSMETRICS'],
          titleShort: ['IT'],
          description: itOperationsDescription,
          link: { name: 'itOperations' },
          buttonText: 'LAUNCH',
          hide: !this.getFlag('DAS-1006'),
        },
        {
          title: ['CALL', 'PLANNING'],
          titleShort: ['C', 'P'],
          description: 'Call Planning in ACTICS',
          link: { name: 'callPlanning' },
          buttonText: 'LAUNCH',
          hide: !user.hasCallPlanning,
        },
        {
          title: ['ITM'],
          titleShort: ['I'],
          description: 'Order management system.',
          link: { name: 'itmOrders' },
          buttonText: 'LAUNCH',
          hide: !this.getFlag('DAS-1199'),
        },
      ].filter(f => !f.hide);
    }
  },
  watch: {
    '$store.state.flags'() {
      this.createMenuItems();
    }
  },
  created() {
    if (!this.$route.query.actics) {
      this.$router.replace({ ...this.$route, query: { ...this.$route.query, actics: 1 } });
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisActicsLandingPage'] = this;
    this.createMenuItems();
  },
}
</script>
